import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import moment from 'moment'

import {deleteMyEvent} from '../../firebase/database/handleMyEvents'

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    paper: {
      display: 'inline-block',
      padding: '1em',
      marginBottom: '1em',
      minWidth: '300px',
      maxWidth: '350px'
    },
    button: {
        margin: theme.spacing.unit,
    },
    textField: {
      marginBottom: theme.spacing.unit *2,
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      
      
    },

    row: {
        border: '2px solid gray',
        padding: '8px',
        marginRight: '4px',
        display: 'inline-block'
    },
    eventDiv: {
        border: '3px solid gray',
        padding: '20px'
    },
    del: {
        color: 'white',
        textWeight: 'bold',
        padding: '4px',
        marginBottom: '8px',
        backgroundColor: 'red',
        cursor  : 'pointer'
    },
    inlineNav: {
        marginTop: '6px'
    },
  });

  const tempStyle = {
      content: {
       

      },

    rowHeadline: {
        fontWeight: 'bold',
        marginBottom: '0.3em',
    },
    rowContent: {
        marginBottom: '0.8em',
        padding: '0.2em',
        borderBottom: '2px solid #3f51b5',
        
    
    },
    rowContentAlert: {
        marginBottom: '0.5em',
        padding: '0.2em',
        borderBottom: '2px solid #f50057',
        fontWeight: 'bold'
    },
    rowInfo: {
        color: 'gray',
        font: '1em',
    },
    navFooter: {
        borderTop: '1px solid gray',
        marginTop: '1em'
    }
  }
class EventDetails extends Component {
   

deleteEvent = (eventId) => {
    const {userId} = this.props
    deleteMyEvent(userId, eventId)
    this.props.doToggleView('EVENTS')

}

renderTime = () => {
    if(this.props.event.timeRange==='onDate'){
        if(this.props.event.time!=='Nach Vereinbarung'){
            return (
                <div>
                    <div style={tempStyle.rowHeadline}>Uhrzeit: </div>
                    <div style={tempStyle.rowContentAlert} >{this.props.event.time}</div>
                </div>
            )
        } else {
            return (
                <div>
                    <div style={tempStyle.rowHeadline}>Uhrzeit: </div>
                    <div style={tempStyle.rowContent}>Uhrzeit nach Vereinbarung</div>
                </div>
            )
        }
    } else {
        return null
    }

}
    render() {
        const { doToggleView, classes } = this.props 
        //const autUserId = this.props.userId
        const {timeRange, date, task, ort, info, id, timeStamp, pkw } = this.props.event
        const eventId = id;
        
        const dateFormatedLong = moment(date).format('dddd DD.MM.YYYY')
        //const dateFormatedShort = moment(date).format('DD.MM.YYYY')
       
        return (
            <div>
                <Paper className={this.props.classes.paper}>
                    <Typography variant="headline" color='primary' gutterBottom>
                        Detailansicht
                    </Typography>
                    <div style={tempStyle.content}> 
                        <Typography variant="subheading" gutterBottom>
                            <div style={tempStyle.rowHeadline} >
                                Ausführung:
                            </div>
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowContentAlert} >Bestimmter Tag</div>
                                : <div style={tempStyle.rowContent} >Nach Vereinbarung</div>
                            }
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowHeadline} >Datum:</div>
                                : <div style={tempStyle.rowHeadline} >Bis zum: </div>
                            }
                            <div style={tempStyle.rowContent} >{dateFormatedLong}</div>
                            {this.renderTime()}
                            <div style={tempStyle.rowHeadline}>Hilfeleistung</div>
                            <div style={tempStyle.rowContent} >{task}</div>
                            <div style={tempStyle.rowHeadline}>Wohnort:</div>
                            <div style={tempStyle.rowContent} >{ort}</div>
                            <div style={tempStyle.rowHeadline}>PKW erforderlich:</div>
                            {pkw
                                ? <div style={tempStyle.rowContentAlert}>JA</div>
                                : <div style={tempStyle.rowContent}>NEIN</div>
                            }
                            <div style={tempStyle.rowHeadline}>Zusatzinformationen</div>
                            <div style={tempStyle.rowContent} >{info}</div>
                        </Typography>
                      
                        <Typography variant="body2" gutterBottom>
                        <div style={styles.row }>Erstellt am {moment(timeStamp).format('dddd DD.MM.YYYY')}</div>
                        <div style={styles.row }>Läuft ab {moment(date, "YYYY-MM-DD").fromNow()}</div>
                        </Typography>  
                    </div>
                    <div style={tempStyle.navFooter}>
                    <Button 
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={()=>doToggleView('EVENTS')}
                        size="small"
                    >
                        Zurück
                    </Button>
                    <Button 
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={()=>this.deleteEvent(eventId)}
                        size="small"
                        style={styles.button}
                    >
                        Löschen
                    </Button>
                    </div>
            
                </Paper>
            </div>
        
        )
    }
}

const mapStateToProps = (state) =>({
    userId: state.sessionState.authUser.uid
})

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(EventDetails)



// WEBPACK FOOTER //
// ./src/Components/Events/EventDetails.js